export const getDocumentName = (documentName: string): string => {
  if (documentName.includes("Originals")) {
    const firstOccurrenceIndex = documentName.indexOf("Originals") + "Originals".length;
    const remainingString = documentName.slice(firstOccurrenceIndex);
    const cleanedRemainingString = remainingString.replace(/Originals/, "");
    documentName = cleanedRemainingString.replace(/^\//, "");
  }

  return `Originals/${documentName}`;
};
